import client from "../config/AxiosConfig";

export const GenerateRequiredStaff = async id => client.get(`/my-wedding/staff/generate-required`);

export const GetStaff = async () =>
  await client.get('/my-wedding/staff');

export const EditStaffList = async data =>
  client.put("/my-wedding/staff/list", data);